import { storesNameRoot } from '../consts';

export const handbookStoreName =
  storesNameRoot + '/handbook';
